export enum EarthwormFoundationRiskLevel {
  INSUFFICIENT_DATA = "",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export const EARTHWORM_DISPLAY_TEXT = {
  [EarthwormFoundationRiskLevel.LOW]: "Low",
  [EarthwormFoundationRiskLevel.MEDIUM]: "Medium",
  [EarthwormFoundationRiskLevel.HIGH]: "High",
  [EarthwormFoundationRiskLevel.INSUFFICIENT_DATA]: "Insufficient Data",
} as const;

export const EARTHWORM_CATEGORY_LABELS = {
  legality: "Legality",
  forest_degradation_hcv: "Forest degradation & HCV impact",
  deforestation: "Deforestation / forest conversion",
  indigenous_rights: "Indigenous People & Local Community rights",
  labour_rights: "Labour and workers rights",
} as const;
